module.exports = __webpack_public_path__ + "img/pic9.0779f9fc.jpg";